import { render, staticRenderFns } from "./_ConceitoAjaxMultiAdicionar.vue?vue&type=template&id=39193a1f&scoped=true"
import script from "./_ConceitoAjaxMultiAdicionar.vue?vue&type=script&lang=ts"
export * from "./_ConceitoAjaxMultiAdicionar.vue?vue&type=script&lang=ts"
import style0 from "./_ConceitoAjaxMultiAdicionar.vue?vue&type=style&index=0&id=39193a1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39193a1f",
  null
  
)

export default component.exports